import { useSelector } from 'react-redux'
import { socketServerSliceSelector } from '../selectors'

export function useSocketServerState() {
  return useSelector(socketServerSliceSelector)
}
